export enum AccountsServiceUrlPaths {
    GetAccountByIdURL = '/{accountId}',
    GetAccountByInvitationCodeURL = '/',
    GetGameAccountsURL = '{accountId}/game-accounts',
    GetGameAccountByIdURL = '{accountId}/game-accounts/{gameAccountId}',
    GetTournamentsByIdURL = '{accountId}/tournaments'
}